import { useDispatch } from "react-redux";

import { Stack, Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import AIAgentTrackingService from "app/pages/sales-intelligence/modules/ai-agent/services/tracking/trackingService";
import { addHumanMessage } from "app/pages/sales-intelligence/modules/ai-agent/store";
import { EmailSuggestion } from "app/pages/sales-intelligence/pages/ai-agent/components/EmailSuggestion/EmailSuggestion";
import { SUGGESTION_TEXTS } from "app/pages/sales-intelligence/pages/ai-agent/constants";

type AIAgentEmailSuggestionsProps = {
    isSuggestionsVisible: boolean;
    isVisualSuggestionVisible: boolean;
    isCompetitorsSuggestionVisible: boolean;
    onPresentVisuals: () => void;
    onPresentCompetitors: () => void;
};

export const AIAgentEmailSuggestions = ({
    isSuggestionsVisible,
    isVisualSuggestionVisible,
    isCompetitorsSuggestionVisible,
    onPresentVisuals,
    onPresentCompetitors,
}: AIAgentEmailSuggestionsProps) => {
    const dispatch = useDispatch();

    const handlePresentVisuals = () => {
        onPresentVisuals();
        AIAgentTrackingService.email.trackApplyVisualSuggestion();
    };

    const handleApplyCompetitorsSuggestion = () => {
        dispatch(addHumanMessage(translate(SUGGESTION_TEXTS[1])));
        onPresentCompetitors();
        AIAgentTrackingService.email.trackApplyCompetitorSuggestion();
    };

    if (!isSuggestionsVisible) {
        return null;
    }

    return (
        <>
            <Box height="172px" />
            <Stack
                gap="12px"
                position="absolute"
                bottom="72px"
                left="12px"
            >
                <EmailSuggestion
                    text={translate(SUGGESTION_TEXTS[0])}
                    onClick={handlePresentVisuals}
                    isVisible={isVisualSuggestionVisible}
                />
                <EmailSuggestion
                    text={translate(SUGGESTION_TEXTS[1])}
                    onClick={handleApplyCompetitorsSuggestion}
                    isVisible={isCompetitorsSuggestionVisible}
                />
            </Stack>
        </>
    );
};
